import Swiper from "swiper";

import 'swiper/css';

const relatedSliderInit = () => {
  new Swiper('.related', {
    slidesPerView: 1,
    slidesPerGroup: 1,
    loop: true,
    breakpoints: {
      1024: {
        slidesPerView: 3,
        spaceBetween: 20,
      },
    },
  });
}

window.addEventListener('load', () => {
  relatedSliderInit()
});

window.addEventListener('resize', () => {
  relatedSliderInit()
});
